/**
 * Contador reverso hasta el 20 de septiembre
 * Diseñado para la página de EXO Niacinamide
 */

class CountdownTimer {
  constructor(targetDate, elementSelector) {
    this.targetDate = new Date(targetDate);
    this.element = document.querySelector(elementSelector);
    this.interval = null;
    
    if (this.element) {
      this.init();
    }
  }

  init() {
    this.updateDisplay();
    this.interval = setInterval(() => {
      this.updateDisplay();
    }, 1000);
  }

  updateDisplay() {
    const now = new Date().getTime();
    const targetTime = this.targetDate.getTime();
    const difference = targetTime - now;

    if (difference > 0) {
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

      this.element.innerHTML = `
        <div class="countdown-timer">
          <div class="countdown-timer__content">
            <div class="countdown-timer__display">
              <div class="countdown-timer__unit">
                <span class="countdown-timer__number">${String(days).padStart(2, '0')}</span>
                <span class="countdown-timer__label">DÍAS</span>
              </div>
              <div class="countdown-timer__separator">:</div>
              <div class="countdown-timer__unit">
                <span class="countdown-timer__number">${String(hours).padStart(2, '0')}</span>
                <span class="countdown-timer__label">HORAS</span>
              </div>
              <div class="countdown-timer__separator">:</div>
              <div class="countdown-timer__unit">
                <span class="countdown-timer__number">${String(minutes).padStart(2, '0')}</span>
                <span class="countdown-timer__label">MINUTOS</span>
              </div>
            </div>
          </div>
        </div>
      `;
    } else {
      // Cuando llega la fecha objetivo - solo mostrar mensaje simple
      this.element.innerHTML = `
        <div class="countdown-timer">
          <div class="countdown-timer__content">
            <div class="countdown-timer__finished">¡YA ESTÁ AQUÍ!</div>
          </div>
        </div>
      `;
      this.clearInterval();
    }
  }

  clearInterval() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  destroy() {
    this.clearInterval();
  }
}

// Inicializar el contador cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  // Fecha objetivo: 20 de septiembre de 2025
  const targetDate = '2025-09-20T00:00:00';
  
  // Inicializar contador para desktop
  const desktopTimer = new CountdownTimer(targetDate, '.countdown-timer-container--desktop');
  
  // Inicializar contador para mobile
  const mobileTimer = new CountdownTimer(targetDate, '.countdown-timer-container--mobile');
  
  // Limpiar intervalos cuando la página se descarga
  window.addEventListener('beforeunload', function() {
    if (desktopTimer) desktopTimer.destroy();
    if (mobileTimer) mobileTimer.destroy();
  });
});